import moment from "moment";
import React, { useState } from "react";
import { calcNights } from "../../../../helper/commonFunction";
import {
  BedIcon,
  DefaultHotelIcon,
  InfoIcon,
  LocationIcon,
  MealIcon,
  UserGroupIcon,
} from "../../../../helper/HwIcon";
import { useHotelUtils } from "../../hooks/useHotelUtils";
import { HotelCheckoutPopup } from "./HotelCheckoutPopup";
import { HotelCancenlationPolicies } from "../../details/components/HotelPolicies";

const boardLabelMap = {
  RO: "Room Only",
  BB: "Breakfast Included",
  HB: "Half Board",
  FB: "Full Board",
  AI: "All Inclusive",
};

export const HotelDetailsCard = ({ details }) => {
  const [showModal, setShowModal] = useState(false);
  const hotelDetails = details?.hotelDetails?.[0];
  const adults = details?.roomDetail?.reduce((a, i) => a + +i?.noOfAdult, 0) || 0;
  const child = details?.roomDetail?.reduce((a, i) => a + +i?.noOfChild, 0) || 0;
  const rooms = details?.roomDetail?.length || 0;
  const nights = calcNights(details?.checkInDate, details?.checkOutDate);

  const { images, ratings, checkIn, checkout } = useHotelUtils(
    hotelDetails,
    details?.apiResponse?.policies?.[0]?.remark
  );
  const remarks = details?.apiResponse?.policies;
  const roomName = details?.apiResponse?.roomInfo?.[0]?.rooomCategory;
  const rawMeal =
    details?.apiResponse?.roomInfo?.[0]?.meal ||
    boardLabelMap[details?.apiResponse?.roomInfo?.[0]?.boardCode] ||
    "";
  const isNoMeal = !rawMeal || /no\s*meal|room\s*only|^ro$/i.test(rawMeal);
  const roomMeal = isNoMeal ? "Room Only" : rawMeal;

  return (
    <div className="hw-passenger--listShow__widget hw-hcard">
      <div className="hw-hcard--head">
        <div className="hw-hcard--thumb">
          {images?.length > 0 ? (
            <img src={images?.[0]} alt={hotelDetails?.name || "hotel"} />
          ) : (
            <DefaultHotelIcon />
          )}
        </div>
        <div className="hw-hcard--headInfo">
          <div className="hw-hcard--titleRow">
            <h3 className="hw-hcard--title">{hotelDetails?.name}</h3>
            {ratings?.length ? (
              <span className="hw-hcard--stars">
                {ratings.map((_, i) => (
                  <span key={i}>★</span>
                ))}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      {hotelDetails?.address ? (
            <div className="hw-hcard--addr">
              <LocationIcon /> {hotelDetails?.address}
            </div>
          ) : null}

      <div className="hw-hcard--divider" />

      <div className="hw-hcard--roomName">{roomName || "Room"}</div>
      <div className="hw-hcard--features">
        <span className="hw-hcard--feat">
          <UserGroupIcon /> {adults} Adult{adults !== 1 ? "s" : ""}
          {child ? ` · ${child} Child` : ""} · {rooms} Room{rooms !== 1 ? "s" : ""}
        </span>
        <span className={`hw-hcard--feat ${isNoMeal ? "" : "hw-hcard--featOk"}`}>
          <MealIcon /> <span className="hw-text--capitalize">{roomMeal}</span>
        </span>
      </div>

      <div className="hw-hcard--stay">
        <div className="hw-hcard--stayCol">
          <span className="hw-hcard--stayLbl">Check-in</span>
          <span className="hw-hcard--stayDate">{moment(details?.checkInDate).format("ddd, DD MMM YYYY")}</span>
          <span className="hw-hcard--stayTime">{checkIn || "1:00 PM"}</span>
        </div>
        
        <div className="hw-hcard--stayCol hw-hcard--stayCol--out">
          <span className="hw-hcard--stayLbl">Check-out</span>
          <span className="hw-hcard--stayDate">{moment(details?.checkOutDate).format("ddd, DD MMM YYYY")}</span>
          <span className="hw-hcard--stayTime">{checkout || "11:00 AM"}</span>
        </div>
      </div>

      <button
        type="button"
        className="hw-hcard--policy"
        onClick={() => setShowModal(true)}
      >
        <InfoIcon /> View booking &amp; cancellation policy
      </button>

      {showModal ? (
        <HotelCheckoutPopup
          title={"Cancellation Policies"}
          onClose={() => setShowModal(false)}
        >
          <HotelCancenlationPolicies title="" overideClassName="" data={remarks} />
        </HotelCheckoutPopup>
      ) : null}
    </div>
  );
};
